import * as React from "react";
import { Card, CardContent, CardHeader } from "@mui/material";

interface StatusCardProps {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

/** Generic card shell used by every dashboard section. Renders whatever it is given — no data shape assumptions. */
export function StatusCard({ title, action, children }: StatusCardProps): React.JSX.Element {
  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardHeader title={title} action={action} titleTypographyProps={{ variant: "subtitle1" }} />
      <CardContent>{children}</CardContent>
    </Card>
  );
}
